import { Component, OnInit } from '@angular/core';
import { SelectionGenericService } from '../../services/selection-generic.service';
import { SharedService } from 'app/modules/common/services/shared-service';

@Component({
    selector: 'app-tab-filters',
    templateUrl: './tab-filters.component.html',
    styleUrls: ['./tab-filters.component.scss'],
    standalone: false
})
export class TabFiltersComponent implements OnInit {

  constructor(public selectionService: SelectionGenericService, public sharedService: SharedService) { }

  ngOnInit() {
  }

}
